import "./index.scss";

import AjaxForm from "../../../components/ajax-form";
import InputsList from "../../../components/inputs-list";

import FileLoader from "../../../components/file-loader/core-file-loader";
import SuggestBlock from "../../../components/suggest-block";

// import OrderBlock from "../utils/order-block";
import { initCompanyBlock } from "../utils/create-company";
import { init as initInputNumber } from "../../../components/input-number";
import { init as initMultiselects } from "../../../components/multiselect";
import { initInterlock } from "../utils/interlock";
import toolbarOptions from "../../services/editor/toolbar";
import formats from "../../services/editor/formats";
import Order from "../../../components/order";
import Toast from "../../../components/modal/toast";
import { initSearchSelect } from "../utils/search-select";
import { restore } from "../../../services/store-form";
import { init as initSelect } from "../../../components/uic-select";
import { init as initSlider } from "../../../components/uic-range";
import { handleAll as handleLinkInputs } from "../../../services/input-handlers/link-input";
import { formatWord } from "../../../services/helpers/format-word";

const order = ((element) => {
    if (element) {
        return new Order(element);
    }

    return null;
})(document.querySelector("form[name=TinkoffPayForm]"));
let companySelect = null;

onDomReady.then(() => {
    InputsList.init();
    // SuggestBlock.init();

    window.qeditor = new Quill(document.getElementById("editor"), {
        modules: {
            toolbar: toolbarOptions
        },
        formats: formats,
        theme: "snow"
    });

    restore();

    document.querySelectorAll("[data-filter-number]").forEach(initInputNumber);
    initMultiselects();
    initCitySelect(document.querySelector("select[name=city]"));
    initCompanySelect(document.querySelector("select[name=companyId]"));
    initTagSelect(document.querySelector("select[name=directionId]"),
        document.querySelector("select[name='tagId']"),
        document.querySelector("[data-hide-container]"));
    initSelectsLike();

    document.getElementById("editor")
    .addEventListener("mousedown", (event) => {
        if (!event.target.closest("[contenteditable]")) {
            event.preventDefault();
            document.querySelector("#editor .ql-editor").focus();
        }
    });

    initSalaryToggler(document.querySelector("[name=isAfterInterviewSalary]"));
    handleLinkInputs();
});

function initSelectsLike() {
    initExperienceSelect(document.querySelector("[data-uic=select-like]"));
}

function initExperienceSelect(element) {
    if (!element) {
        return;
    }

    window.addEventListener("mousedown", (e) => {
        const closest = e.target.closest("[data-uic=select-like]");
        element.classList.toggle("opened", closest === element);
    });

    const formatter = (value) => {
        value = value | 0;

        if (value === -2) {
            return "Любой";
        }
        else if (value === -1) {
            return "Без опыта";
        }
        else if (value < 1) {
            return "< 1 года";
        }
        else if (value <= 10) {
            return value + " " + formatWord(value, [ "год", "года", "лет" ]);
        }
        else {
            return "10+ лет";
        }
    };
    const input = element.querySelector(".uic-select__input");
    const sliderElement = element.querySelector("[data-slider]");
    const slider = initSlider(sliderElement, {
        format: formatter
    });

    slider.onUpdate((value) => {
        input.classList.remove("placeholder");
        input.value = formatter(value);
    });
}

function initTagSelect(direction, pureTag, hideContainer) {
    if (!direction || !pureTag) {
        return;
    }

    const tagData = getTagData();
    const tag = initSelect(pureTag);
    const tagContainer = pureTag.parentNode;
    const areaSelect = hideContainer.querySelector("select[name=areaId]") || {};

    function onDirectionUpdated() {
        const value = direction.value;
        const tags = tagData[value] || [];
        const hasTags = tags.length;

        tagContainer.classList.toggle("hide-select", !hasTags);
        hideContainer.classList.toggle("d-none", !hasTags);
        tag.input.value = "";
        tag.clear();
        tags.forEach(([ value, text ]) => tag.add({ value, text }));
        areaSelect.disabled = !hasTags;

        if ("selected" in pureTag.dataset) {
            const active = tags.find(item => item[1] === pureTag.dataset.selected);

            delete pureTag.dataset.selected;

            if (active) {
                tag.select(active[0]);
            }
        }
    }

    direction.addEventListener("change", onDirectionUpdated);
    onDirectionUpdated();
}

function initSalaryToggler(toggler) {
    if (!toggler) {
        return;
    }

    const updateSalaryBlock = () => {
        document.querySelector("[data-salary-block]")
            .classList.toggle("block-hidden", toggler.checked);
    };

    toggler.addEventListener("change", updateSalaryBlock);
    updateSalaryBlock();
}

function initCompanySelect(el) {
    if (!el) {
        return;
    }

    companySelect = initSearchSelect(el, {
        dispatch(select, { companies }) {
            companies.forEach(({ id: value, name: text }) => select.add({ value, text }))
        }
    });
}

function initCitySelect(el) {
    if (!el) {
        return;
    }

    const select = initSearchSelect(el, {
        dispatch(select, { cities }) {
            cities.forEach(({ name: value }) => select.add({ value }));
        }
    });

    document.querySelector("select[name=vacancyWorkPlace]")
        .addEventListener("change", (e) => {
            select.input.disabled = e.target.value === "remote";
        });
    
    ((select, togglerSelect) => {
        select.input.disabled = togglerSelect.value === "remote";
    })(select, document.querySelector("select[name=vacancyWorkPlace]"));
}

function getTagData() {
    const data = window.__tagData || [];
    const result = {};

    for (const { id, tags } of data) {
        result[id] = (tags || "").split(",").filter(i => i).map(pair => pair.split(":"));
    }

    delete window.__tagData;

    return result;
}

const vacancyConfig = window.vacancyConfig || {};

var form = document.getElementById("vacancy-form");

let previewLoader = form.querySelector('.file-loader');
new FileLoader(previewLoader, {
    uploadField: "image",
    loadedField: "vacancyImages[]",
});

const SubmitButton = {
    enable(btn) {
        if (btn) {
            btn.disabled = false;
            btn.removeAttribute("data-loading");
        }
    },
    disable(btn) {
        if (btn) {
            btn.disabled = true;
            btn.setAttribute("data-loading", "");
        }
    }
};

const errorToastMessages = {
    "companyId": "Выберите компанию для публикации"
};

let vacancyForm = new AjaxForm(form, {
    validationRules: vacancyConfig.validationRules,

    // перед отправкой удалить пустые поля
    beforeSubmit: function(data) {
        const filteredFields = ["requirements[]", "tasks[]", "conditions[]"];
        
        const result = data.filter(function(fieldName, fieldValue) {
            if (filteredFields.indexOf(fieldName) !== -1) {
                if (!fieldValue) return false;
            }
            return true;
        });

        for (const name of [ "isCandidateEmailHidden", "isAfterInterviewSalary" ]) {
            result.set(name, +(result.get(name) === "on"));
        }

        result.set("vacancyDescription", window.qeditor.container.firstChild.innerHTML);

        SubmitButton.disable(form.querySelector("button[type=submit]"));

        return result;
    },

    // после добавления в заказ обновить данные заказа
    afterSubmit: function(res) {
        if (form.dataset.headRole != '1' && order) {
            order.addItem("vacancy", res.vacancyId)
                .then(() => SubmitButton.enable(form.querySelector("button[type=submit]")));
        }
        else if (res.redirectUrl) {
            window.location.href = res.redirectUrl;
        }
    },

    handleErrors(validation) {
        let toastMsgs = [];

        for (const key in validation) {
            const input = form.querySelector(`[name="${ key }"]`);
            let container = null;

            if (container = input?.closest("[data-uic=input]")) {
                container.classList.add("error");
            }
            else if (container = form.querySelector(`.multiselect[data-name="${ key }[]"]`)) {
                container.classList.add("error");
            }

            toastMsgs.push(validation[key]);
        }

        if (toastMsgs.length) {
            Toast.open(toastMsgs.join(". "), { state: "error" });
        }
    }
});

initInterlock();

initCompanyBlock({
    form: form,
    validationRules: vacancyConfig.companyValidationRules || {},
    displayCompany(data) {
        if (companySelect) {
            const value = data.companyId;
            const text = data.companyName;

            companySelect.add({ value, text });
            companySelect.select(value);
        }
    }
});
